(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/subscription-info.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/subscription-info.js');

'use strict';

svs.numbergames.game.views.SubscriptionInfo = Marionette.View.extend({
  className: 'subscription-info',
  template(data) {
    return svs.numbergames.game.templates.subscription_info(data);
  },
  onAttach() {
    this.animations = svs.numbergames.game.animations.showHideView.animateShowHide({
      el: this.$el,
      callbackScope: this,
      onHide() {
        this.constructor.__super__.destroy.apply(this);
      }
    });
    this.animations.show();
  },
  destroy() {
    this.animations.hide();
  }
});

 })(window);